export default __webpack_public_path__ + "static/media/Group849.8be728af.svg";